import { BaseStore } from '@store/base-store.ts';
import { makeAutoObservable, runInAction } from 'mobx';
import AnnotationSelectorEnum from '@components/data/annotation-selector/annotation-selector-enum.ts';
import authStore from '@store/auth-store.ts';
import {
	LocalStorageKey,
	LocalStorageKeyType,
} from '@/enums/local-storage-types.ts';
import localStorageService from '@services/local-storage-service.ts';

class AnnotationStateStore implements BaseStore {
	private _showIcons = true;
	private _showBanners = true;
	private _showRobuxPrice = true;
	private _showDailyPicks = true;

	reset() {
		runInAction(() => {
			this._showIcons = true;
			this._showBanners = true;
			this._showRobuxPrice = true;
			this._showDailyPicks = true;
		});
	}

	constructor() {
		makeAutoObservable(this);
	}

	init(userId: number) {
		runInAction(() => {
			this._showIcons =
				localStorageService.get(
					this.localStorageKey(AnnotationSelectorEnum.ICONS),
					userId
				) !== 'false';

			this._showBanners =
				localStorageService.get(
					this.localStorageKey(AnnotationSelectorEnum.BANNERS),
					userId
				) !== 'false';

			this._showRobuxPrice =
				localStorageService.get(
					this.localStorageKey(AnnotationSelectorEnum.ROBUX_HISTORY),
					userId
				) !== 'false';

			this._showDailyPicks =
				localStorageService.get(
					this.localStorageKey(AnnotationSelectorEnum.DAILY_PICKS),
					userId
				) !== 'false';
		});
	}

	setState(state: boolean, annotation: AnnotationSelectorEnum) {
		runInAction(() => {
			switch (annotation) {
				case AnnotationSelectorEnum.ICONS:
					this._showIcons = state;
					break;
				case AnnotationSelectorEnum.BANNERS:
					this._showBanners = state;
					break;
				case AnnotationSelectorEnum.ROBUX_HISTORY:
					this._showRobuxPrice = state;
					break;
				case AnnotationSelectorEnum.DAILY_PICKS:
					this._showDailyPicks = state;
					break;
			}
		});

		if (authStore.isLoggedIn) {
			localStorageService.set(
				this.localStorageKey(annotation),
				`${state}`,
				authStore.user?.id
			);
		}
	}

	get showIcons() {
		return this._showIcons;
	}

	get showBanners() {
		return this._showBanners;
	}

	get showRobuxPrice() {
		return this._showRobuxPrice;
	}

	get showDailyPicks() {
		return this._showDailyPicks;
	}

	private localStorageKey(type: AnnotationSelectorEnum): LocalStorageKeyType {
		return `${LocalStorageKey.ChartAnnotationState}-${type}`;
	}
}

const annotationStateStore = new AnnotationStateStore();
export default annotationStateStore;
